import { useEffect, useState } from 'react';

import { Dialog, DialogButton, Input } from '@/components/ui';

type ChatRenameDialogProps = {
  open: boolean;
  initialTitle: string;
  saving?: boolean;
  onClose: () => void;
  onSave: (title: string) => void | Promise<void>;
};

export function ChatRenameDialog({
  open,
  initialTitle,
  saving,
  onClose,
  onSave,
}: ChatRenameDialogProps) {
  const [title, setTitle] = useState(initialTitle);

  useEffect(() => {
    if (open) {
      setTitle(initialTitle);
    }
  }, [open, initialTitle]);

  async function submit() {
    await onSave(title.trim());
  }

  return (
    <Dialog
      open={open}
      title="Rename conversation"
      onClose={onClose}
      footer={
        <>
          <DialogButton label="Cancel" onPress={onClose} disabled={saving} />
          <DialogButton
            label="Save"
            variant="primary"
            disabled={saving || !title.trim()}
            onPress={() => void submit()}
          />
        </>
      }
    >
      <Input
        autoFocus
        label="Title"
        value={title}
        onChange={(event) => setTitle(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter' && title.trim()) {
            event.preventDefault();
            void submit();
          }
        }}
      />
    </Dialog>
  );
}
